<template>
    <div 
      :data-progress="valueCounter > value ? value : valueCounter"
      class="circular-progress__outer-circle rounded-circle mx-1"
      :class="{ small: size === 'small', medium: size === 'medium', large: size === 'large' }"
      :style="{'--progress': degreesCounter + 'deg', '--textBgColor': textBgColor, '--textColor': textColor}"
    >
        <div 
            :data-progress="valueCounter > value ? value : valueCounter"
            :class="{ 
                small: size === 'small', 
                medium: size === 'medium', 
                large: size === 'large',
                'circular-progress__inner-circle rounded-circle' : true,
                'show-percentage' : showPercentageValue
            }"
   
        >
            <slot v-if="!showPercentageValue"></slot>
        </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'CircularProgress',
    props: {
      showPercentageValue: {
        type: Boolean,
        default: false
      },
      value: {
        type: Number,
        default: 0,
        required: true,
      },
      size: {
        type: String,
        default: 'small',
        validator(value) {
          return ['small', 'medium', 'large'].includes(value)
        }
      },
      textBgColor: {
        type: String,
        default: '#FFFFFF'
      },
      textColor: {
        type: String,
        default: "#296DB3"
      }
    },
  
    data() {
      return {
        valueCounter: 0,
        degreesCounter: 0,
        valueCounterIntervalId: null,
        degreesIntervalId: null
      };
    },
  
    computed: {
      degrees() {
        return Math.floor((this.value * 360)/100)
      },
    },
  
    watch: {
      degrees:{
        immediate: true,
        handler(newValue) {
          if (Number(newValue) > 0) {
            this.degreesCounter = 0;
            this.degreesIntervalId = setInterval(() => {
              this.degreesCounter += 1
            }, 10)
          } else {
            this.degreesCounter = 0;
          }
        }
      },
      value:{
        immediate: true,
        handler(newValue) {
          if (Number(newValue) > 0) {
            this.valueCounter = 0;
            this.valueCounterIntervalId = setInterval(() => {
              this.valueCounter += 1
            }, 40)
          } else {
            this.valueCounter = 0
          }
        }
      },
      degreesCounter(newValue) {
        if (newValue == this.degrees) {
          clearInterval(this.degreesIntervalId)
        }
      },
      valueCounter(newValue) {
        if (newValue >= this.value) {
          clearInterval(this.valueCounterIntervalId)
        } 
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
    .circular-progress {
        &__outer-circle {
            position: relative;  
            padding: 5px;  
            background: conic-gradient(#296DB3 calc(var(--progress) * 0.70), #29B32F calc(var(--progress)), #F4F7FB 0deg);  
            display: flex;
            align-items: center;
            justify-content: center;
            &.small {
                width: 65px;
                height: 65px;
            }
            &.medium {
                width: 88px;
                height: 88px;
            }
            &.large {
                width: 120px;
                height: 120px;
            }
            &.small::after {
                margin: 5px;
                font-size: 13px;
            }
            &.medium::after {
                margin: 6px;
                font-size: 16px;
            }
            &.large::after {
                margin: 10px;
                font-size: 24px;
            }
        }
        &__inner-circle {
            border-radius: 50%;
            background-color: var(--textBgColor);
            &.small {
                width: 55px;
                height: 55px;
            }
            &.medium {
                width: 78px;
                height: 78px;
            }
            &.large {
                width: 110px;
                height: 110px;
            }
            &.show-percentage {
                position: relative;
                display: inline-flex;
                align-items: center;
                justify-content: center;
            }
            &.show-percentage::after {
                content: attr(data-progress) "%";   
                background-color: var(--textBgColor);
                color: var(--textColor);
                font-weight: 500;
                text-align: center;
            }
            &.show-percentage.small::after {
                font-size: 13px;
            }
            &.show-percentage.medium::after {
                font-size: 16px;
            }
            &.show-percentage.large::after {
                font-size: 24px;
            }
        }   
    }

  

  </style>